import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const hash = window.location.hash.replace('#/', '').replace('#', '') || 'home';
    setCurrentPage(hash);
    const onHash = () => {
      const h = window.location.hash.replace('#/', '').replace('#', '') || 'home';
      setCurrentPage(h);
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const navigate = (page) => {
    setCurrentPage(page);
    window.location.hash = page === 'home' ? '' : page;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'about': return <About navigate={navigate} />;
      case 'contact': return <Contact navigate={navigate} />;
      case 'faq': return <FAQ navigate={navigate} />;
      case 'privacy': return <Privacy navigate={navigate} />;
      case 'terms': return <Terms navigate={navigate} />;
      default: return <Home navigate={navigate} />;
    }
  };

  return (
    <div className="app">
      <Navbar navigate={navigate} currentPage={currentPage} />
      <main>{renderPage()}</main>
      <Footer navigate={navigate} />
    </div>
  );
}

export default App;
